import { useCallback, useMemo } from 'react';
import EngagementHistoryWrapper from 'crm-events-components/internal/engagementHistory/EngagementHistoryWrapper';
import { ENGAGEMENT } from 'customer-data-objects/constants/ObjectTypes';
import { OPEN_ENGAGEMENT_HISTORY, updateEngagementHistory } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
export const useEngagementHistoryActionHandler = () => {
  const handleEngagementHistoryAction = useCallback((actionType, data) => {
    if (actionType === OPEN_ENGAGEMENT_HISTORY) {
      const {
        engagementOrInteractionType,
        engagementId
      } = data;
      updateEngagementHistory(engagementOrInteractionType, engagementId, ENGAGEMENT);
      return;
    }
    return;
  }, []);
  const renderedEngagementHistoryWrapper = useMemo(() => {
    return /*#__PURE__*/_jsx(EngagementHistoryWrapper, {});
  }, []);
  return {
    handleEngagementHistoryAction,
    engagementHistoryWrapper: renderedEngagementHistoryWrapper
  };
};